import ReactGA from 'react-ga4';

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';

export const initGA = () => {
  if (!MEASUREMENT_ID) return;
  ReactGA.initialize(MEASUREMENT_ID);
};

export const trackPageView = (path: string) => {
  if (!MEASUREMENT_ID) return;
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const trackEvent = (category: string, action: string, label?: string) => {
  if (!MEASUREMENT_ID) return;
  ReactGA.event({ category, action, label });
};
